import { Route, Routes } from 'react-router-dom';

import SuggestedSubCategoriesList from './SuggestedSubCategoriesList';

function SuggestedSubCategoriesModule() {
  return (
    <Routes>
      <Route path="" element={<SuggestedSubCategoriesList />} />
    </Routes>
  );
}
export default SuggestedSubCategoriesModule;
